/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { PaginatedResponseWarehouseCaseResponseDTOFromJSON, WarehouseCaseAttachmentDTOFromJSON, WarehouseCaseAttachmentLinkDTOFromJSON, WarehouseCaseCategoryDTOFromJSON, WarehouseCaseCountsDTOFromJSON, WarehouseCaseCreateDTOToJSON, WarehouseCaseMessageCreateDTOToJSON, WarehouseCaseMessageDTOFromJSON, WarehouseCaseResponseDTOFromJSON, WarehouseCaseUnreadCountDTOFromJSON, } from '../models/index';
/**
 *
 */
export class WarehouseCaseControllerApi extends runtime.BaseAPI {
    /**
     */
    async addMessageRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling addMessage().');
        }
        if (requestParameters['warehouseCaseMessageCreateDTO'] == null) {
            throw new runtime.RequiredError('warehouseCaseMessageCreateDTO', 'Required parameter "warehouseCaseMessageCreateDTO" was null or undefined when calling addMessage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/messages`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseCaseMessageCreateDTOToJSON(requestParameters['warehouseCaseMessageCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseMessageDTOFromJSON(jsonValue));
    }
    /**
     */
    async addMessage(requestParameters, initOverrides) {
        const response = await this.addMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async createCaseRaw(requestParameters, initOverrides) {
        if (requestParameters['warehouseCaseCreateDTO'] == null) {
            throw new runtime.RequiredError('warehouseCaseCreateDTO', 'Required parameter "warehouseCaseCreateDTO" was null or undefined when calling createCase().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseCaseCreateDTOToJSON(requestParameters['warehouseCaseCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async createCase(requestParameters, initOverrides) {
        const response = await this.createCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteCaseAttachmentRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling deleteCaseAttachment().');
        }
        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter "attachmentId" was null or undefined when calling deleteCaseAttachment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/attachments/{attachmentId}`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        urlPath = urlPath.replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteCaseAttachment(requestParameters, initOverrides) {
        await this.deleteCaseAttachmentRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getCaseRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling getCase().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getCase(requestParameters, initOverrides) {
        const response = await this.getCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getCaseMessageAttachmentLinkRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling getCaseMessageAttachmentLink().');
        }
        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter "attachmentId" was null or undefined when calling getCaseMessageAttachmentLink().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/message-attachments/{attachmentId}/link`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        urlPath = urlPath.replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseAttachmentLinkDTOFromJSON(jsonValue));
    }
    /**
     */
    async getCaseMessageAttachmentLink(requestParameters, initOverrides) {
        const response = await this.getCaseMessageAttachmentLinkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getMessagesRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling getMessages().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/messages`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WarehouseCaseMessageDTOFromJSON));
    }
    /**
     */
    async getMessages(requestParameters, initOverrides) {
        const response = await this.getMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getUnreadCountRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/unread-count`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseUnreadCountDTOFromJSON(jsonValue));
    }
    /**
     */
    async getUnreadCount(initOverrides) {
        const response = await this.getUnreadCountRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getWarehouseCaseCountsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }
        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        if (requestParameters['lastMessageFrom'] != null) {
            queryParameters['lastMessageFrom'] = requestParameters['lastMessageFrom'].toISOString();
        }
        if (requestParameters['lastMessageTo'] != null) {
            queryParameters['lastMessageTo'] = requestParameters['lastMessageTo'].toISOString();
        }
        if (requestParameters['hideClosed'] != null) {
            queryParameters['hideClosed'] = requestParameters['hideClosed'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/counts`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseCountsDTOFromJSON(jsonValue));
    }
    /**
     */
    async getWarehouseCaseCounts(requestParameters = {}, initOverrides) {
        const response = await this.getWarehouseCaseCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCaseCategoriesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/categories`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WarehouseCaseCategoryDTOFromJSON));
    }
    /**
     */
    async listCaseCategories(initOverrides) {
        const response = await this.listCaseCategoriesRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listCasesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }
        if (requestParameters['warehousePackageId'] != null) {
            queryParameters['warehousePackageId'] = requestParameters['warehousePackageId'];
        }
        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }
        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }
        if (requestParameters['unreadOnly'] != null) {
            queryParameters['unreadOnly'] = requestParameters['unreadOnly'];
        }
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        if (requestParameters['lastMessageFrom'] != null) {
            queryParameters['lastMessageFrom'] = requestParameters['lastMessageFrom'].toISOString();
        }
        if (requestParameters['lastMessageTo'] != null) {
            queryParameters['lastMessageTo'] = requestParameters['lastMessageTo'].toISOString();
        }
        if (requestParameters['awaitingSupport'] != null) {
            queryParameters['awaitingSupport'] = requestParameters['awaitingSupport'];
        }
        if (requestParameters['hideClosed'] != null) {
            queryParameters['hideClosed'] = requestParameters['hideClosed'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseWarehouseCaseResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listCases(requestParameters = {}, initOverrides) {
        const response = await this.listCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCasesForPackageRaw(requestParameters, initOverrides) {
        if (requestParameters['warehousePackageId'] == null) {
            throw new runtime.RequiredError('warehousePackageId', 'Required parameter "warehousePackageId" was null or undefined when calling listCasesForPackage().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/by-package/{warehousePackageId}`;
        urlPath = urlPath.replace(`{${"warehousePackageId"}}`, encodeURIComponent(String(requestParameters['warehousePackageId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WarehouseCaseResponseDTOFromJSON));
    }
    /**
     */
    async listCasesForPackage(requestParameters, initOverrides) {
        const response = await this.listCasesForPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async markReadRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling markRead().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/mark-read`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async markRead(requestParameters, initOverrides) {
        await this.markReadRaw(requestParameters, initOverrides);
    }
    /**
     */
    async reopenWarehouseCaseRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling reopenWarehouseCase().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/reopen`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async reopenWarehouseCase(requestParameters, initOverrides) {
        const response = await this.reopenWarehouseCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async uploadCaseAttachmentRaw(requestParameters, initOverrides) {
        if (requestParameters['caseNumber'] == null) {
            throw new runtime.RequiredError('caseNumber', 'Required parameter "caseNumber" was null or undefined when calling uploadCaseAttachment().');
        }
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling uploadCaseAttachment().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/warehouse-cases/{caseNumber}/attachments`;
        urlPath = urlPath.replace(`{${"caseNumber"}}`, encodeURIComponent(String(requestParameters['caseNumber'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCaseAttachmentDTOFromJSON(jsonValue));
    }
    /**
     */
    async uploadCaseAttachment(requestParameters, initOverrides) {
        const response = await this.uploadCaseAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetWarehouseCaseCountsStatusEnum = {
    Open: 'OPEN',
    AwaitingCustomer: 'AWAITING_CUSTOMER',
    Resolved: 'RESOLVED',
    Closed: 'CLOSED'
};
/**
 * @export
 */
export const ListCasesStatusEnum = {
    Open: 'OPEN',
    AwaitingCustomer: 'AWAITING_CUSTOMER',
    Resolved: 'RESOLVED',
    Closed: 'CLOSED'
};
